<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            right
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodoMovimentacao"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodoMovimentacao"
                            end-label="Até"
                            range
                            right
                            start-label="Período movimentação de"
                            v-model="model.periodoMovimentacao"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.relatorioSolicitacao.paciente"
                            :request-query-string-params="autocompleteQueryStringParams.paciente"
                            :search-fields="autocompleteFields.paciente"
                            :text-field="p => `${p.nome}${p.nomeSocial ? ` (${p.nomeSocial})` : ''}${p.cns ? ` - ${p.cns}` : ''}`"
                            :validations="validations.paciente"
                            @select="loadFrom('paciente')"
                            label="Paciente"
                            placeholder="Nome, Nome social, CNS, CPF, Data de nascimento ou Prontuário"
                            v-model="model.paciente"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="1">
                        <rkm-form-input
                            :validations="validations.idadeDe"
                            @change="loadFrom('idadeDe')"
                            label="Idade de"
                            number
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-input
                            :validations="validations.idadeAte"
                            @change="loadFrom('idadeAte')"
                            label="Até"
                            number
                            v-model="model.idadeAte"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-multiselect
                            :disabled="disabledUnidadesReguladoras"
                            :options="form.unidadesReguladoras"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('unidadeReguladora')"
                            label="Unidade(s) reguladora(s)"
                            option-text-selecteds="item"
                            optionNameKey="nomeFantasia"
                            show-default-option
                            v-model="model.unidadesReguladoras"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-multiselect
                            :disabled="disabledReguladores"
                            :options="form.reguladores"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('regulador')"
                            label="Local(is) de atendimento regulador(es)"
                            option-text-selecteds="item"
                            optionNameKey="nome"
                            show-default-option
                            v-model="model.reguladores"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-multiselect
                            :disabled="disabledUnidadesSolicitantes"
                            :options="form.unidadesSolicitantes"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('unidadeSolicitante')"
                            label="Unidade(s) solicitante(s)"
                            option-text-selecteds="item"
                            optionNameKey="nomeFantasia"
                            show-default-option
                            v-model="model.unidadesSolicitantes"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledInfraestruturasSolicitantes"
                            :options="form.infraestruturasSolicitantes"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('infraestruturaSolicitante')"
                            label="Local(is) de atendimento solicitante(s)"
                            option-text-selecteds="item"
                            optionNameKey="nome"
                            show-default-option
                            v-model="model.infraestruturasSolicitantes"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledUnidadesReferencias"
                            :none="true"
                            :options="form.unidadesReferencias"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('unidadeReferencia')"
                            label="Unidade(s) referência(s)"
                            option-text-selecteds="item"
                            optionNameKey="nomeFantasia"
                            show-default-option
                            v-model="model.unidadesReferencias"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledUsuariosSolicitantes"
                            :options="form.usuariosSolicitantes"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('usuarioSolicitante')"
                            label="Profissional(is) solicitante(s)"
                            option-text-selecteds="item"
                            optionNameKey="nome"
                            show-default-option
                            v-model="model.usuariosSolicitantes"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledPrestadores"
                            :none="true"
                            :options="form.prestadores"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('prestador')"
                            label="Prestador(es)"
                            option-text-selecteds="item"
                            show-default-option
                            v-model="model.prestadores"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-multiselect
                            :disabled="disabledStatus"
                            :options="form.status"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('status')"
                            label="Status"
                            option-text-selecteds="item"
                            show-default-option
                            v-model="model.status"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-multiselect
                            :disabled="disabledOpcoesRetiradaProtocoloAgendamento"
                            :none="true"
                            :options="form.opcoesRetiradaProtocoloAgendamento"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('opcaoRetiradaProtocoloAgendamento')"
                            label="Retirada(s) de protocolo(s)"
                            option-text-selecteds="item"
                            optionNameKey="nome"
                            show-default-option
                            v-model="model.opcoesRetiradaProtocoloAgendamento"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledGrupos"
                            :load-all-automatically="false"
                            :options="form.grupos"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('grupo')"
                            label="Grupo(s)"
                            option-text-selecteds="item"
                            show-default-option
                            v-model="model.grupos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledExames"
                            :load-all-automatically="false"
                            :options="form.exames"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('exame')"
                            label="Exame(s)"
                            option-text-selecteds="item"
                            optionNameKey="descricao"
                            show-default-option
                            v-model="model.exames"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledProcedimentosCirurgicos"
                            :load-all-automatically="false"
                            :options="form.procedimentosCirurgicos"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('procedimentoCirurgico')"
                            label="Procedimento(s) cirúrgico(s)"
                            option-text-selecteds="item"
                            optionNameKey="descricao"
                            show-default-option
                            v-model="model.procedimentosCirurgicos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledEspecialidades"
                            :load-all-automatically="false"
                            :options="form.especialidades"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('especialidade')"
                            label="Especialidade(s)"
                            option-text-selecteds="item"
                            optionNameKey="descricao"
                            show-default-option
                            v-model="model.especialidades"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :disabled="disabledPrioridades"
                            :options="form.prioridades"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('prioridade')"
                            label="Prioridade(s)"
                            option-name-key="nome"
                            option-text-selecteds="item"
                            v-model="model.prioridades"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :disabled="disabledCid"
                            :repository="repositories.relatorioSolicitacao.cid"
                            :request-query-string-params="autocompleteQueryStringParams.cid"
                            :search-fields="autocompleteFields.cid"
                            :text-field="c => `${c.codigo} - ${c.nome}`"
                            label="CID"
                            v-model="model.cid"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :disabled="disabledCiap"
                            :repository="repositories.relatorioSolicitacao.ciap"
                            :request-query-string-params="autocompleteQueryStringParams.ciap"
                            :search-fields="autocompleteFields.ciap"
                            :text-field="c => `${c.codigo} - ${c.descricao}`"
                            label="CIAP"
                            v-model="model.ciap"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-multiselect
                            :disabled="disabledEspecialidades"
                            :options="form.sexos"
                            :select-limit="null"
                            label="Sexo(s)"
                            option-text-selecteds="item"
                            optionNameKey="descricao"
                            show-default-option
                            v-model="model.sexos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :disabled="!hasProcedimentoSelected || model.prioridades.length === 0 || model.sexos.length === 0"
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                class="table-resultado"
            >
                <template v-slot:cell(itens)="{ value }">
                    <div
                        v-for="item in value"
                        :key="item"
                    >
                        {{ item }}
                    </div>
                </template>

                <template
                    v-if="itens.length > 0"
                    #afterTable
                >
                    <div class="table-resultado-header-footer">
                        <rkm-row>
                            <rkm-col class="text-center">
                                <span>
                                    <strong>Total de solicitações:</strong> {{ getSafely(() => totalizadores.solicitacoes, 0) }}
                                </span>

                                <span class="ml-4">
                                    <strong>Total de pacientes:</strong> {{ getSafely(() => totalizadores.pacientes, 0) }}
                                </span>

                                <span class="ml-4">
                                    <strong>Total de locais de atendimento solicitantes:</strong> {{ getSafely(() => totalizadores.infraestruturasSolicitantes, 0) }}
                                </span>

                                <span class="ml-4">
                                    <strong>Total de prestadores:</strong> {{ getSafely(() => totalizadores.prestadores, 0) }}
                                </span>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="mt-2">
                            <rkm-col class="text-center">
                                <span>
                                    <strong>Total por status:</strong>
                                </span>

                                <div
                                    v-for="(status, i) in getSafely(() => totalizadores.porStatus, [])"
                                    :key="i"
                                    class="totalizador-status"
                                    :class="{ 'ml-1': i == 0, 'ml-3': i > 0 }"
                                >
                                    <span>{{ status.nome }}: {{ status.quantidade }}</span>
                                </div>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file, formats } from '@/mixins'

export default {
    computed: {
        autocompleteQueryStringParams() {

            const params = this.prepareData()

            return {
                paciente: { ...params },
                cid: { ...params },
                ciap: { ...params },
            }
        },
        autocompleteFields() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                    { key: 'cidadao.nomeSocial', searchable: true },
                    { key: 'cidadao.cns', searchable: true },
                    { key: 'cidadao.cpf', searchable: true },
                    { key: 'cidadao.data_nascimento', searchable: true },
                    { key: 'paciente.prontuario', searchable: true },
                ],
                cid: [
                    { key: 'cid.codigo', searchable: true },
                    { key: 'cid.nome', searchable: true },
                ],
                ciap: [
                    { key: 'ciap.codigo', searchable: true },
                    { key: 'ciap.descricao', searchable: true },
                ],
            }
        },
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: { required: !this.isPeriodoMovimentacaoSelected && !this.isPacienteSelected },
                periodoMovimentacao: { required: !this.isPeriodoSelected && !this.isPacienteSelected },
                paciente: { required: !this.isPeriodoSelected && !this.isPeriodoMovimentacaoSelected },
            }
        },
        disabledUnidadesReguladoras() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledReguladores() {

            return this.model.unidadesReguladoras.length === 0
        },
        disabledUnidadesSolicitantes() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledInfraestruturasSolicitantes() {

            return this.model.unidadesSolicitantes.length === 0
        },
        disabledUnidadesReferencias() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledUsuariosSolicitantes() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledPrestadores() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledStatus() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledOpcoesRetiradaProtocoloAgendamento() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledGrupos() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledExames() {

            return this.model.grupos.length === 0
        },
        disabledProcedimentosCirurgicos() {

            return this.model.grupos.length === 0
        },
        disabledEspecialidades() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledPrioridades() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledCid() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledCiap() {

            return !this.hasSomeRequiredFieldSelected
        },
        disabledSexos() {

            return !this.hasSomeRequiredFieldSelected
        },
        hasProcedimentoSelected() {

            return this.model.exames.length > 0
                || this.model.procedimentosCirurgicos.length > 0
                || this.model.especialidades.length > 0
        },
        hasSomeRequiredFieldSelected() {

            return this.isPeriodoSelected || this.isPeriodoMovimentacaoSelected || this.isPacienteSelected
        },
        isPeriodoSelected() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
        isPeriodoMovimentacaoSelected() {

            return this.model !== null
                && (this.model.periodoMovimentacao.start instanceof Date)
                && (this.model.periodoMovimentacao.end instanceof Date)
        },
        isPacienteSelected() {

            return !!this.model.paciente
        }
    },
    created() {

        this.repositories = {
            relatorioSolicitacao: this.getConectaSusRepository('regulacao.relatorioSolicitacao'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            exportacao: this.getConectaSusRepository('exportacao.regulacao'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'posicao',
                'pacienteNome',
                'pacienteProntuario',
                'pacienteIdade',
                'sexoDescricao',
                'pacienteCpf',
                'pacienteCns',
                'itens',
                'cid',
                'statusNome',
                'infraestruturaSolicitanteNome',
                'tempoEspera',
            ],
            sortBy: 'data',
            sortDesc: false,
            columns: [
                {
                    key: 'data',
                    label: 'Data da solicitação',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    sortable: true,
                    fixed: true,
                },
                { key: 'posicao', label: 'Posição', sortable: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true },
                { key: 'pacienteProntuario', label: 'Prontuário', sortable: true },
                { key: 'pacienteIdade', label: 'Idade', sortable: true },
                { key: 'sexoDescricao', label: 'Sexo', sortable: true },
                { key: 'pacienteCpf', label: 'CPF', sortable: true },
                { key: 'pacienteCns', label: 'CNS', sortable: true },
                { key: 'itens', label: 'Procedimento' },
                { key: 'cid', label: 'CID', sortable: true },
                { key: 'ciap', label: 'CIAP', sortable: true },
                { key: 'statusNome', label: 'Status', sortable: true },
                {
                    key: 'dataAgendada',
                    label: 'Data do agendamento',
                    formatter: value => value ? this.formatDate(value) : null,
                    filterByFormatted: true,
                    sortable: true,
                },
                { key: 'infraestruturaSolicitanteNome', label: 'Local de atendimento solicitante', sortable: true },
                { key: 'reguladorNome', label: 'Regulador', sortable: true },
                { key: 'usuarioSolicitanteNome', label: 'Usuário solicitante', sortable: true },
                { key: 'prestadorNome', label: 'Prestador', sortable: true },
                { key: 'usuarioCadastroNome', label: 'Usuário que cadastrou', sortable: true },
                { key: 'tempoEspera', label: 'Tempo de espera', sortable: true },
            ],
            itens: [],
            totalizadores: null,
            unwatchers: {
                periodo: null,
                periodoMovimentacao: null,
                paciente: null,
            }
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        load() {

            this.setLoading()

            this.repositories.relatorioSolicitacao.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.unwatchers.periodo = this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        if (this.isPacienteSelected) {

                            this.loadFrom('paciente')
                        }
                        else if (this.isPeriodoMovimentacaoSelected) {

                            this.loadFrom('periodoMovimentacao')
                        }
                        else {

                            this.resetAfterPeriodo()
                        }
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })

            this.unwatchers.periodoMovimentacao = this.$watch('model.periodoMovimentacao', {
                deep: true,
                handler(periodoMovimentacao) {

                    if (periodoMovimentacao.start === null || periodoMovimentacao.end === null) {

                        if (this.isPacienteSelected) {

                            this.loadFrom('paciente')
                        }
                        else if (this.isPeriodoSelected) {

                            this.loadFrom('periodo')
                        }
                        else {

                            this.resetAfterPeriodo()
                        }
                    }
                    else {

                        this.loadFrom('periodoMovimentacao')
                    }
                }
            })

            this.unwatchers.paciente = this.$watch('model.paciente', paciente => {

                if (!paciente) {

                    this.loadFrom('paciente')
                }
            })
        },
        unwatcherFields() {

            this.unwatchers.periodo()
            this.unwatchers.periodoMovimentacao()
            this.unwatchers.paciente()
        },
        loadFrom(field) {

            this.setLoading()

            this.repositories.relatorioSolicitacao.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {

            this.setLoading()

            this.repositories.relatorioSolicitacao.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.solicitacoes
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.unwatcherFields()

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
            this.addWatchers()
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo
            delete model.periodoMovimentacao
            delete model.paciente
            delete model.idadeDe
            delete model.idadeAte

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioSolicitacao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioSolicitacao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            data.selected_cols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            data.totais_opcoes = {
                unidades_reguladoras: this.form.unidadesReguladoras.length,
                reguladores: this.form.reguladores.length,
                unidades_solicitantes: this.form.unidadesSolicitantes.length,
                infraestruturas_solicitantes: this.form.infraestruturasSolicitantes.length,
                unidades_referencias: this.form.unidadesReferencias.length,
                usuarios_solicitantes: this.form.usuariosSolicitantes.length,
                prestadores: this.form.prestadores.length,
                status: this.form.status.length,
                opcoes_retirada_protocolo_agendamento: this.form.opcoesRetiradaProtocoloAgendamento.length,
                grupos: this.form.grupos.length,
                exames: this.form.exames.length,
                procedimentos_cirurgicos: this.form.procedimentosCirurgicos.length,
                especialidades: this.form.especialidades.length,
                prioridades: this.form.prioridades.length,
                sexos: this.form.sexos.length,
            }

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.formateDates(data.periodoMovimentacao, ['start', 'end'], 'DD/MM/YYYY')
            this.createIdKeysToObject(data, ['paciente', 'cid', 'ciap'])

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, error, data, object, stringCase, file, formats],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}

.table-resultado >>> .table-resultado-header-footer {
    background: #f1f1f1;
    border: 1px solid #dee2e6;
    color: var(--gray-dark);
    font-weight: 600;
    padding: 0.5rem;
}

.totalizador-status {
    display: inline-block;
}
</style>